module.exports = __webpack_public_path__ + "static/media/default.c5ec9754.jpg";